import React from "react";

const iconMap = {
  document: { src: `${process.env.PUBLIC_URL}/file-icon.svg`, alt: "document icon" },
  image: { src: `${process.env.PUBLIC_URL}/img-icon.svg`, alt: "photo icon" },
  media: { src: `${process.env.PUBLIC_URL}/media-icon.svg`, alt: "video icon" },
  archive: { src: `${process.env.PUBLIC_URL}/folder-zip.svg`, alt: "archive icon" },
  folderEmpty: { src: `${process.env.PUBLIC_URL}/Folder-empty.svg`, alt: "folder icon" },
  folderFilled: { src: `${process.env.PUBLIC_URL}/folder-new.svg`, alt: "folder with files" },
  default: { src: `${process.env.PUBLIC_URL}/file-icon.svg`, alt: "file icon" },
};

const fileTypeForExtension = (ext = "") => {
  const lower = ext.toLowerCase();
  if (["doc", "docx", "txt", "pdf"].includes(lower)) return "document";
  if (["jpg", "jpeg", "png", "gif", "webp", "svg"].includes(lower)) return "image";
  if (["mp3", "wav", "ogg", "flac", "aac", "mp4", "avi", "mov", "mkv", "wmv", "flv", "webm"].includes(lower)) {
    return "media";
  }
  if (["zip", "rar", "7z", "tar", "gz"].includes(lower)) return "archive";
  return "default";
};

const inferTypeFromName = (fileName = "", hasChildren = false) => {
  const normalized = (fileName || "").trim().replace(/\/+$/, "");
  const hasExtension = normalized.includes(".");

  if (!hasExtension) {
    return hasChildren ? "folderFilled" : "folderEmpty";
  }

  const extension = normalized.split(".").pop();
  return fileTypeForExtension(extension);
};

const resolveType = (fileType, fileName, hasChildren) => {
  if (fileType === "folderFilled") return "folderFilled";
  if (fileType === "folderEmpty") return "folderEmpty";
  if (fileType === "folder") return hasChildren ? "folderFilled" : "folderEmpty";
  if (fileType === "image") return "image";
  if (fileType === "video" || fileType === "media") return "media";
  if (fileType === "archive") return "archive";
  if (fileType === "document") return "document";
  return inferTypeFromName(fileName, hasChildren);
};

const FileIcon = ({ fileName = "", fileType, hasChildren = false, className = "w-[80px] h-[60px]" }) => {
  const type = resolveType(fileType, fileName, hasChildren);
  const icon = iconMap[type] || iconMap.default;

  return <img src={icon.src} alt={icon.alt} className={className} />;
};

export default FileIcon;

